// Bridge to the Android/iOS app shells (apps/mobile). In a normal browser
// there is no window.Capacitor and every call here does nothing. Inside the
// app, the signed-in crew token is handed to native storage so the home-screen
// widget can show today's numbers without the app open.

type TrimWidgetPlugin = {
  setSession(opts: { token: string; origin: string }): Promise<void>;
  clearSession(): Promise<void>;
};
type CapacitorGlobal = { isNativePlatform?: () => boolean; Plugins?: { TrimWidget?: TrimWidgetPlugin } };

function widget(): TrimWidgetPlugin | null {
  const cap = (window as unknown as { Capacitor?: CapacitorGlobal }).Capacitor;
  return cap?.isNativePlatform?.() ? cap.Plugins?.TrimWidget ?? null : null;
}

export function shareSessionWithWidget(token: string): void {
  void widget()?.setSession({ token, origin: window.location.origin }).catch(() => { /* widget just shows "Open Trim Log" */ });
}

export function clearWidgetSession(): void {
  void widget()?.clearSession().catch(() => {});
}
